export const PersonModalNavigation = Object.freeze({
    ADDRESS_FORMATTER: "ADDRESS_FORMATTER",
    ADDRESS_MANUAL: "ADDRESS_MANUAL",
    CONFIRM: "CONFIRM",
    FORM: "FORM",
    NAME: "NAME",
});
